import React from 'react';

export default class Gallery extends React.Component {
  render() {
    return (
      <div>
<div className="wrapper" id="gallery">
  <div className="column">
    <div className="inner"></div>
  </div>
  <div className="column">
    <div className="inner"></div>
  </div>
  <div className="column">
    <div className="inner"></div>
  </div>
  <div className="column">
    <div className="inner"></div>
  </div>
  <div className="column">
    <div className="inner"></div>
  </div>
  <div className="column">
    <div className="inner"></div>
  </div>
  <div className="column">
    <div className="inner"></div>
  </div>
  <div className="column">
    <div className="inner"></div>
  </div>
  <div className="column">
    <div className="inner"></div>
  </div>
  <div className="column">
    <div className="inner"></div>
  </div>
  <div className="column">
    <div className="inner"></div>
  </div>
  <div className="column">
    <div className="inner"></div>
  </div>
</div>
<hr />
</div>
);
}
}



// WEBPACK FOOTER //
// ./src/layout/Gallery.js